var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldKeyholeRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4783 4.10895L11.113 1.3735C10.9505 1.3043 10.6754 1.24768 10.503 1.24768C10.3273 1.24768 10.0521 1.3043 9.88964 1.37377L3.52429 4.10922C2.93053 4.3616 2.54297 4.96059 2.54297 5.59309C2.54297 14.4172 8.81549 18.7524 10.4698 18.7524C12.1938 18.7524 18.4563 14.3694 18.4563 5.59309C18.4563 4.96059 18.0684 4.3616 17.4783 4.10895ZM10.503 2.88977C10.5063 2.88977 10.503 2.88943 10.503 2.88977ZM10.4698 17.1113C7.43301 15.795 4.13629 11.6377 4.13629 5.62728C4.13629 5.62898 4.13629 5.62557 4.13629 5.62728L10.4619 2.90447C10.4729 2.901 10.4865 2.89414 10.5041 2.89081L16.865 5.59309C16.865 12.5471 12.701 16.1643 10.4698 17.1113ZM8.64309 8.35897C8.64309 9.12138 9.07839 9.77439 9.70398 10.0824V12.4616C9.70398 12.9163 10.062 13.2822 10.4997 13.2822C10.9373 13.2822 11.2953 12.9146 11.2953 12.4616V10.0821C11.9209 9.77411 12.3562 9.12104 12.3562 8.35862C12.3562 7.30116 11.5251 6.44405 10.4997 6.44405C9.47423 6.44405 8.64309 7.30253 8.64309 8.35897Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldKeyholeRegular);
export default __webpack_public_path__ + "static/media/shield-keyhole-regular.7f8c4e113a3a155ba9624e2544f76433.svg";
export { ForwardRef as ReactComponent };